import { cn } from 'lib/helpers/utility';

import Skeleton from 'components/shared/Skeleton/Skeleton';
import Typography from 'components/shared/Typography/Typography';

const PaymentMethodsSkeletonItem = ({ className }) => {
  return (
    <div className="flex h-fit w-full rounded-lg border border-solid border-neutral-200 bg-white px-3 py-3.5">
      <div className="flex w-full gap-2">
        <Skeleton height="18px" width="18px" />
        <div className={cn('flex w-full items-center justify-between gap-2', className)}>
          <Skeleton height="20px" width="128px" />
          <Skeleton height="15px" width="160px" />
        </div>
      </div>
    </div>
  );
};

const PaymentMethodsSkeleton = ({ title, count = 6, itemClassName }) => {
  return (
    <div className="flex flex-col gap-5">
      {title && (
        <Typography variant="p" size="small" color="neutral-800" weight="medium">
          {title}
        </Typography>
      )}
      <div className="flex flex-col gap-2">
        {Array.from({ length: count }, (_, index) => (
          <PaymentMethodsSkeletonItem key={index} className={itemClassName} />
        ))}
      </div>
    </div>
  );
};

export default PaymentMethodsSkeleton;
